import Localbase from 'localbase'
let db = new Localbase('db')

export default db;